import React, { Component } from "react";
import uuidv4 from "uuid/v4";
import { Alert } from "react-bootstrap";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { id: "", error: null, info: null };
  }

  // Update state so the next render will show the fallback UI.
  static getDerivedStateFromError(error) {
    return { id: uuidv4(), error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary.error:", error);
    console.error("ErrorBoundary.errorInfo:", info);

    this.setState({ info });

    //  Send the error to New Relic
    if ("newrelic" in window) {
      window.newrelic.noticeError(error, { id: this.state.id, ...info });
    }
  }

  render() {
    return this.state.error ? (
      <Alert variant="danger" style={{ margin: "15px" }}>
        <p>
          <strong>Something went wrong.</strong>
        </p>
        <p>Please attach the information below when reporting the issue.</p>
        <p>Error ID: {this.state.id}</p>
        <p>Error Message: {this.state.error.message}</p>
        <p>User Agent: {window.navigator.userAgent}</p>

        {this.state.info && (
          <div>
            <pre>Component Stack: {this.state.info.componentStack}</pre>
          </div>
        )}
      </Alert>
    ) : (
      this.props.children
    );
  }
}
